import { render, staticRenderFns } from "./Sobre.vue?vue&type=template&id=093d9018&scoped=true&"
import script from "./Sobre.vue?vue&type=script&lang=ts&"
export * from "./Sobre.vue?vue&type=script&lang=ts&"
import style0 from "./Sobre.vue?vue&type=style&index=0&id=093d9018&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "093d9018",
  null
  
)

export default component.exports